import React, { useState } from 'react';
import { 
  HomeIcon, 
  UsersIcon, 
  DocumentTextIcon,
  PhoneIcon,
  MicrophoneIcon,
  MapIcon,
  CogIcon,
  UserIcon,
  ArrowRightOnRectangleIcon,
  Bars3Icon,
  XMarkIcon,
  MagnifyingGlassIcon,
  BellIcon,
  CurrencyDollarIcon,
  DocumentChartBarIcon,
  BuildingOfficeIcon
} from '@heroicons/react/24/outline';

import AdminLayoutWrapper from './common/AdminLayoutWrapper';

// Crown Icon Component
const CrownIcon = ({ size = 24, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M5 16L3 8l2.5 2L12 4l6.5 6L21 8l-2 8H5zm2.5-7L6 8l1 4h10l1-4-1.5 1L12 7 7.5 9z"/>
  </svg>
);



// Main Content Area
const MainContent = ({ children }) => {
  return (
    <AdminLayoutWrapper>
        {children}
    </AdminLayoutWrapper>
  );
};

// Dashboard Home Component (placeholder)
const DashboardHome = () => {
  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        {/* Welcome Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-4">
            <CrownIcon size={40} className="text-yellow-500" />
            <div>
              <h1 className="text-3xl font-bold text-white">Welcome Back, William Walker</h1>
              <p className="text-gray-400">Manage your operations from the admin dashboard</p>
            </div>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <UsersIcon className="h-8 w-8 text-white" />
              </div>
              <div className="ml-5">
                <p className="text-purple-200 text-sm font-medium">Total Leads</p>
                <p className="text-2xl font-bold text-white">1,247</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-xl p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <PhoneIcon className="h-8 w-8 text-white" />
              </div>
              <div className="ml-5">
                <p className="text-green-200 text-sm font-medium">Active Campaigns</p>
                <p className="text-2xl font-bold text-white">8</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-yellow-600 to-yellow-700 rounded-xl p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <CurrencyDollarIcon className="h-8 w-8 text-white" />
              </div>
              <div className="ml-5">
                <p className="text-yellow-200 text-sm font-medium">Total Charges</p>
                <p className="text-2xl font-bold text-white">$12,450</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <DocumentTextIcon className="h-8 w-8 text-white" />
              </div>
              <div className="ml-5">
                <p className="text-blue-200 text-sm font-medium">Documents</p>
                <p className="text-2xl font-bold text-white">342</p>
              </div>
            </div>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="bg-gray-800 border border-gray-700 rounded-xl p-6">
          <h2 className="text-xl font-semibold text-white mb-4">Recent Activity</h2>
          <div className="space-y-4">
            <div className="flex items-center justify-between py-3 border-b border-gray-700">
              <div className="flex items-center space-x-3">
                <div className="flex-shrink-0">
                  <PhoneIcon className="h-5 w-5 text-green-500" />
                </div>
                <div>
                  <p className="text-white font-medium">Campaign "Texas Outreach" completed</p>
                  <p className="text-gray-400 text-sm">147 calls made successfully</p>
                </div>
              </div>
              <span className="text-gray-400 text-sm">2 hours ago</span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-gray-700">
              <div className="flex items-center space-x-3">
                <div className="flex-shrink-0">
                  <UsersIcon className="h-5 w-5 text-blue-500" />
                </div>
                <div>
                  <p className="text-white font-medium">New lead imported</p>
                  <p className="text-gray-400 text-sm">Jason Smith from California</p>
                </div>
              </div>
              <span className="text-gray-400 text-sm">4 hours ago</span>
            </div>

            <div className="flex items-center justify-between py-3">
              <div className="flex items-center space-x-3">
                <div className="flex-shrink-0">
                  <CurrencyDollarIcon className="h-5 w-5 text-yellow-500" />
                </div>
                <div>
                  <p className="text-white font-medium">New charge added</p>
                  <p className="text-gray-400 text-sm">$1,200 violation fee processed</p>
                </div>
              </div>
              <span className="text-gray-400 text-sm">6 hours ago</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main Admin Layout Component
const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-gray-900">
      {/*<Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />*/}
      
      
        {/*<Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />*/}
        
        <MainContent>
          <DashboardHome />
        </MainContent>
      
    </div>
  );
};

export default AdminLayout;